export const SERVICE_PROVIDER_LANGUAGE = {
  service_provider_add_information: "Information",
  service_provider_add_company_name: "Name",
  service_provider_view_filter_list: "Line of Business",
  service_provider_add_company_name_msg: "Name is required",
  service_provider_add_company_name_limit: "Character must be less than 50",
  service_provider_add_company_email_label: " Email Address",
  service_provider_add_company_email_error: "Email Address is required",
  service_provider_add_company_email_validation: "Invalid Email",
  service_provider_add_company_address_label: "Address",
  service_provider_add_company_address_error: "Address is required",
  service_provider_add_company_address_validation: "Character must be less than 300",
  service_provider_add_company_city_label: "City",
  service_provider_add_company_city_error: "City is required",
  service_provider_add_upload: "Upload",
  service_provider_view_name: "Service Provider Name",
  service_provider_view_top_bar_search: "Search",
  service_provider_view_provider_list: "Service Provider",
  service_provider_view_add_provider: "Add",
  service_provider_view_last_update: "Last Update",
  service_provider_POC_text: "Point of Contact",
  service_provider_POC_add_poc: "Point of Contact",
  service_provider_POC_view_email: "Email Address",
  service_provider_POC_view_line_of_business: "Line of Business",
  service_provider_POC_view_designation: "Designation",
  service_provider_POC_view_city: "City",
  service_provider_POC_view_top_bar_search: "Search",
  service_provider_POC_add_save: "Save",
  service_provider_POC_add_name: "Name",
  service_provider_POC_add_number: "Contact Number",
  service_provider_POC_add_name_error: "Name is required",
  service_provider_POC_add_name_length_error: "Name must be smaller than 50 characters",
  service_provider_POC_add_contact: "Contact Number",
  service_provider_POC_add_contact_error: "Contact Number is required",
  service_provider_POC_add_email: "Email Address",
  service_provider_POC_add_invalid_email_error: "Invalid email",
  service_provider_POC_add_designation: "Designation",
  service_provider_POC_add_designation_error: "Designation is required",
  service_provider_POC_add_designation_character_error: "Name must be smaller than 50 characters",
  service_provider_POC_add_city: "City",
  service_provider_POC_add_city_error: "City is required",
  service_provider_POC_add_line_of_business: "Line of Business",
  service_provider_POC_add_line_of_business_error: "Line of business is required err",
  service_provider_info_text: "Information"
};
